import { render } from "./CrudTabelaPreco.vue?vue&type=template&id=157e9f16"
import script from "./CrudTabelaPreco.vue?vue&type=script&lang=ts"
export * from "./CrudTabelaPreco.vue?vue&type=script&lang=ts"
script.render = render

export default script